const Privacy250410 = () => {
	return (
		<>
			<div className="terms-content">
				<div className="terms-box">
					<p>
						주식회사 핑거(이하 '회사'라 함)는 “스텔라” 서비스를 제공함에 있어 개인정보 보호법, 신용정보의 이용 및 보호에
						관한 법률, 정보통신망 이용촉진 및 정보보호(이하 ‘정보통신망법’) 등 개인정보 보호에 관한 관련 법령에 따라
						이용자의 개인정보 및 권익을 보호하고 개인정보와 관련한 이용자의 고충을 원활하게 처리할 수 있도록 다음과 같은
						처리방침을 두고 있습니다. 회사는 개인정보 처리방침을 통하여 이용자가 제공하는 개인정보가 어떠한 용도와
						방식으로 이용되고 있으며, 개인정보 보호를 위해 어떠한 조치가 취해지고 있는지 알려 드립니다. 회사 개인정보
						처리방침은 정부의 법률 및 지침의 변경과 회사 내부 정책의 변화에 따라 변경될 수 있으며 변경된 개인정보
						처리방침은 사이트에 게시합니다.
					</p>
				</div>
				<div className="terms-box">
					<h4 className="terms-title">1. 개인정보의 처리 목적</h4>
					<p>
						회사는 다음의 목적을 위하여 개인정보를 처리합니다. 처리하고 있는 개인정보는 다음의 목적 이외의 용도로는
						이용되지 않으며, 이용 목적이 변경되는 경우에는 개인정보 보호법에 따라 별도의 동의를 받는 등 필요한 조치를
						이행할 것입니다.
					</p>
					<ol className="terms-depth">
						<li className="depth">
							<span>1)</span>회원가입 및 관리
							<p>
								회원 가입의사 확인, 서비스 제공에 따른 본인 식별·인증, 회원자격 유지·관리, 서비스 부정이용 방지, 각종
								고지·통지, 분쟁 조정을 위한 기록 보존, 유료 서비스 제공을 위한 식별 및 인증, 민원사항처리 및 분쟁 해결을
								위한 원활한 의사소통 경로의 확보 등
							</p>
						</li>
						<li className="depth">
							<span>2)</span>서비스 제공 및 마케팅·광고에의 활용
							<p>
								서비스 개선 및 신규서비스 개발, 콘텐츠 제공, 맞춤 서비스 제공, 이벤트 및 광고성 정보 제공, 접속빈도 파악
								또는 회원의 서비스 이용에 대한 통계 등
							</p>
						</li>
						<li className="depth">
							<span>3)</span>서비스 제공에 관한 계약 이행 및 민원 사무처리
							<p>
								스텔라 서비스 제공, 콘텐츠 제공, 특정 맞춤 서비스 제공, 서비스 이용에 대한 과금 및 요금 결제, 본인인증,
								청구서 등 발송, 요금 추심 등
							</p>
						</li>
						<li className="depth">
							<span>4)</span>법적 분쟁 시 증거로 활용
						</li>
					</ol>
				</div>
				<div className="terms-box">
					<h4 className="terms-title">2. 수집 및 처리하는 개인정보의 항목</h4>
					<p>
						회사는 “스텔라” 회원가입 서비스 제공 및 문의사항 응대를 위해 아래와 같은 최소한의 개인정보를 수집합니다.
					</p>
					<p>개인정보 수집방법: 회원가입 및 개별 서비스 이용 시, 고객문의, 이벤트 응모</p>

					<div className="table table-col align-center">
						<table>
							<colgroup>
								<col style={{ width: '10%' }} />
								<col style={{ width: '18%' }} />
								<col />
								<col style={{ width: '22%' }} />
								<col style={{ width: '17%' }} />
							</colgroup>
							<thead>
								<tr>
									<th>서비스</th>
									<th>수집방법</th>
									<th>필수항목</th>
									<th>선택항목</th>
									<th>보유기간</th>
								</tr>
							</thead>
							<tbody>
								<tr>
									<td rowSpan={4}>스텔라</td>
									<td>회원가입</td>
									<td>
										회사명, 대표자명, 사업자유형, 아이디, <br />
										이메일주소, 가입자명, 휴대폰번호
									</td>
									<td>매출액, 직원수, 직원형태, 가입경로</td>
									<td rowSpan={3}>
										해당 서비스 해지 · 취소 시 <br />
										또는 회원탈퇴 까지
									</td>
								</tr>
								<tr>
									<td>
										전자세금
										<br />
										계산서 발행
									</td>
									<td>회사명, 사업자등록번호, 대표자명, 연락처, 담당자명, 이메일, 팩스번호</td>
									<td></td>
								</tr>
								<tr>
									<td>
										거래수집
										<br />
										(스크래핑서비스) <br />· 금융내역 제공
									</td>
									<td>
										카드매출 조회(여신금융협회 ID/PW)
										<br />
										· 은행계좌 조회 (은행ID/PW, 공동인증서/계좌명/계좌번호)
										<br />
										· 카드 조회(카드사 홈페이지 ID/PW, 공동인증서)
										<br />· 홈택스 조회(홈택스 공동인증서)
									</td>
									<td></td>
								</tr>
								<tr>
									<td>
										고객문의 상담
										<br />
										(서비스 문의, 제휴 문의)
									</td>
									<td>회사명, 이름, 휴대폰번호, 이메일주소</td>
									<td></td>
									<td>정보를 제공받은 날로부터 3 년 까지</td>
								</tr>
							</tbody>
						</table>
					</div>
				</div>
				<div className="terms-box">
					<h4 className="terms-title">3. 개인정보의 제3자 제공 및 위탁</h4>
					<ol className="terms-depth">
						<li className="depth">
							<span>1)</span>회사는 이용자들의 개인정보를 “1. 개인정보의 처리 및 수집 목적, 2. 수집 및 처리하는
							개인정보의 항목”에서 고지한 범위 내에서 이용하며, 이용자의 사전 동의 없이는 동 범위를 초과하여 이용하거나
							제3자에게 제공하지 않습니다. 다만, 아래의 경우에는 예외로 합니다.
							<ol className="terms-depth">
								<li className="depth">
									<span>①</span> 이용자들이 사전에 정보 제공에 동의한 경우
								</li>
								<li className="depth">
									<span>②</span> 법령의 규정에 의거하거나 법령 상 준수의무를 위하여 불가피한 경우
								</li>
								<li className="depth">
									<span>③</span> 이용자 또는 제3자의 생명, 신체, 재산 이익을 위하여 필요한 경우
								</li>
								<li className="depth">
									<span>④</span> 개인정보처리자의 정당한 이익을 위해 필요한 경우
								</li>
								<li className="depth">
									<span>⑤</span> 공공의 안전과 안녕을 위해 긴급히 필요한 경우
								</li>
							</ol>
						</li>
						<li className="depth">
							<span>2)</span> 개인정보 제3자 제공
							<p>
								회사는 서비스의 원활한 업무처리를 위하여 개인정보 제3자 제공에 동의한 회원에 대해 다음과 같이 개인정보
								제공합니다.
							</p>
							<div className="table table-col align-center">
								<table>
									<colgroup>
										<col style={{ width: '13%' }} />
										<col style={{ width: '22%' }} />
										<col />
										<col style={{ width: '22%' }} />
									</colgroup>
									<thead>
										<tr>
											<th>제공받는 자</th>
											<th>이용 목적</th>
											<th>제공정보 항목</th>
											<th>보유 및 이용기간</th>
										</tr>
									</thead>
									<tbody>
										<tr>
											<td>링크허브</td>
											<td>
												전자세금계산서 <br />
												발행/수신/보관/집계 서비스
											</td>
											<td>회사명, 사업자등록번호, 대표자명, 연락처, 담당자명, 이메일, 팩스번호</td>
											<td rowSpan={2}>
												개인정보 수집 시 동의 받은 <br />
												개인정보 보유∙이용기간 내
											</td>
										</tr>
										<tr>
											<td>삼일회계 법인</td>
											<td>스텔라 서비스 공동 마케팅</td>
											<td>
												<p>회사명, 대표자명, 사업자유형, 아이디, 이메일주소, 가입자명, 휴대폰번호</p>
											</td>
										</tr>
									</tbody>
								</table>
							</div>
						</li>
						<li className="depth">
							<span>3)</span> 개인정보 처리 위탁
							<p>
								회사는 서비스의 원활한 업무처리를 위하여 다음과 같이 개인정보 처리업무를 위탁하고 있습니다. 위탁업무의
								내용이나 수탁자가 변경될 경우에는 지체없이 본 개인정보 처리방침을 통하여 공개하도록 하겠습니다
							</p>
							<div className="table table-col align-center">
								<table>
									<colgroup>
										<col style={{ width: '25%' }} />
										<col style={{ width: '25%' }} />
										<col />
									</colgroup>
									<thead>
										<tr>
											<th>제공받는 자</th>
											<th>위탁업무 내용</th>
											<th>개인정보보유 및 이용기간</th>
										</tr>
									</thead>
									<tbody>
										<tr>
											<td>
												주식회사
												<br />
												다우기술
											</td>
											<td>휴대폰 인증, 알림톡, 문자메세지 발송</td>
											<td rowSpan={5}>회원 탈퇴 시 혹은 위탁 계약 종료시까지</td>
										</tr>
										<tr>
											<td>
												나이스디앤알
												<br />
												주식회사
											</td>
											<td>모바일상품권 발송</td>
										</tr>
										<tr>
											<td>효성에프엠에스㈜</td>
											<td>자동이체 결제서비스</td>
										</tr>
										<tr>
											<td>나이스페이먼츠㈜</td>
											<td>결제서비스</td>
										</tr>
										<tr>
											<td>엔에이치엔클라우드(주)</td>
											<td>클라우딩 서비스</td>
										</tr>
									</tbody>
								</table>
							</div>
						</li>
					</ol>
				</div>
				<div className="terms-box">
					<h4 className="terms-title">4. 개인정보의 처리 및 이용기간</h4>
					<p>
						회사는 법령에 따른 개인정보 보유·이용기간 또는 이용자로부터 개인정보를 수집 시에 동의 받은 개인정보
						보유·이용기간 내에서 개인정보를 처리·보유합니다. 단, 관계법령의 규정에 의하여 보존할 필요가 있는 경우 회사는
						아래와 같이 관계법령에서 정한 일정한 기간 동안 이용자 정보를 보관합니다. 각각의 개인정보 처리 및 보유 기간은
						다음과 같습니다.
					</p>
					<ol className="terms-depth">
						<li className="depth">
							<span>1)</span> 고객상담 및 민원처리: 고객상담 및 민원업무 종료 시까지
						</li>
						<li className="depth">
							<span>2)</span> 마케팅 및 광고에 활용: 이용에 대한 동의 시부터 동의 철회 시까지
						</li>
						<li className="depth">
							<span>3)</span> 관계 법령에 의한 개인정보 보유
							<ol className="terms-depth">
								<li className="depth">
									<span>①</span> 계약 또는 청약철회 등에 관한 기록 보존 이유: 전자상거래 등에서의 소비자보호에 관한 법률
									/ 보존 기간 5년
								</li>
								<li className="depth">
									<span>②</span> 대금결제 및 재화 등의 공급에 관한 기록 보존 이유: 전자상거래 등에서의 소비자보호에 관한
									법률 / 보존 기간 5년
								</li>
								<li className="depth">
									<span>③</span> 전자금융 거래에 관한 기록 보존 이유: 전자금융거래법 / 보존 기간 5년
								</li>
								<li className="depth">
									<span>④</span> 소비자의 불만 또는 분쟁처리에 관한 기록 보존 이유: 전자상거래 등에서의 소비자보호에
									관한 법률 / 보존 기간3년
								</li>
								<li className="depth">
									<span>⑤</span> 신용정보의 수집/처리 및 이용 등에 관한 기록 보존 이유: 신용정보의 이용 및 보호에 관한
									법률 / 보존기간 3년
								</li>
								<li className="depth">
									<span>⑥</span> 로그인 기록 보존 이유: 통신비밀보호법 / 보존 기간 3개월
								</li>
								<li className="depth">
									<span>⑦</span> 공인전자주소 및 전자문서 유통 정보 보존 이유: 전자문서 및 전자거래 기본법 / 보존기간
									10년
								</li>
								<li className="depth">
									<span>⑧</span> 표시, 광고에 관한 기록: 6개월
								</li>
								<li className="depth">
									<span>⑨</span> 관계 법령 위반에 따른 수사, 조사 등이 진행 중인 경우: 해당 수사, 조사 종료시까지
								</li>
							</ol>
						</li>
					</ol>
				</div>
				<div className="terms-box">
					<h4 className="terms-title">5. 개인정보의 파기절차 및 방법</h4>
					<ol className="terms-depth">
						<li className="depth">
							<span>1)</span>회사는 원칙적으로 회원 탈퇴 시 (개인정보 수집 및 이용목적이 달성된 후) 이용자의 개인정보를
							지체없이 파기합니다.
						</li>
						<li className="depth">
							<span>2)</span>이용자로부터 동의를 받은 개인정보의 보유기간이 경과하거나 처리 목적이 달성되었음에도
							불구하고 다른 법령에 따라 개인정보를 계속 보존하여야 하는 경우에는 해당 개인정보를 별도의 데이터베이스로
							옮기거나 보관장소를 달리하여 보존합니다.
						</li>
						<li className="depth">
							<span>3)</span> 개인정보 파기의 절차, 기한 및 방법은 다음과 같습니다
							<ol className="terms-depth">
								<li className="depth">
									<span>①</span> 전자적 파일 형태의 정보는 기록을 복구 및 재생할 수 없도록 기술적 방법을 사용하여
									안전하게 삭제합니다.
								</li>
								<li className="depth">
									<span>②</span> 종이에 출력된 개인정보는 분쇄기로 분쇄하거나 소각을 통하여 파기합니다.
								</li>
							</ol>
						</li>
					</ol>
				</div>
				<div className="terms-box">
					<h4 className="terms-title">6. 이용자 및 법정 대리인의 권리와 그 행사방법</h4>
					<ol className="terms-depth">
						<li className="depth">
							<span>1)</span>개인정보의 열람 및 정정
							<ul className="bullet-dash">
								<li className="bullet">
									이용자 또는 그 법정대리인은 언제든지 등록되어 있는 본인의 개인정보를 열람 및 정정할 수 있습니다.
								</li>
								<li className="bullet">
									개인정보 열람 및 정정은 로그인 후 ['마이페이지-개인정보수정']을 클릭하여 직접 열람 또는 정정할 수
									있으며, 개인정보 담당부서 및 보호책임자에게 서면, 전화, 이메일로 연락하시면 즉시 조치하겠습니다.
								</li>
								<li className="bullet">
									회사는 이용자가 개인정보의 오류에 대한 정정을 요청한 경우, 정정을 완료하기 전까지 당해 개인정보를
									이용하지 않습니다. 또한, 잘못된 개인정보를 제3자에게 이미 제공한 경우에는 정정 처리결과를 제3자에게
									지체없이 통지하여 정정이 이루어지도록 조치하겠습니다.
								</li>
							</ul>
						</li>
						<li className="depth">
							<span>2)</span>동의 철회 및 삭제 요청
							<ul className="bullet-dash">
								<li className="bullet">
									이용자 또는 그 법정대리인은 언제든지 회사의 개인정보의 수집/이용, 개인정보 제3자 제공, 국외 이전 등
									대한 동의를 철회하거나 회원 탈퇴를 요청할 수 있습니다.
								</li>
								<li className="bullet">
									동의 철회 및 회원 탈퇴는 개인정보 담당부서 및 보호책임자에게 서면, 전화, 이메일로 연락하시면 즉시
									개인정보의 삭제 등 필요한 조치를 취하도록 하겠으며, 이용자 또는 법정대리인의 요청에 의해 삭제된
									개인정보는 "4. 개인정보의 처리 및 이용기간"에 명시된 바에 따라 처리하고, 그 외의 용도로 열람 또는
									이용할 수 없도록 처리하고 있습니다.
								</li>
							</ul>
						</li>
						<li className="depth">
							<span>3)</span>거절
							<p>
								회사는 다음에 해당하는 경우에는 개인정보의 전부 또는 일부에 대하여 열람·정정 및 삭제를 거절할 수
								있습니다. 정정 및 삭제 거절의 경우 아래 1항의 사유에 한합니다.
							</p>
							<ol className="terms-depth">
								<li className="depth">
									<span>①</span>법률에 따라 열람·정정 및 삭제가 금지되거나 제한되는 경우
								</li>
								<li className="depth">
									<span>②</span>다른 사람의 생명·신체를 해할 우려가 있거나 다른 사람의 재산과 그 밖의 이익을 부당하게
									침해할 우려가 있는 경우
								</li>
							</ol>
						</li>
						<li className="depth">
							<span>4)</span>14세 미만의 아동의 개인정보 처리와 법정대리인의 동의
							<p>
								14세 미만 아동의 개인정보를 처리할 경우에는 법정대리인의 동의를 받아야 합니다. 법정대리인은 아동의
								개인정보를 조회하거나 수정 및 삭제, 처리정지 및 동의 철회 등의 권리를 행사할 수 있습니다. 법정대리인
								동의를 받기 위하여 아동에게 법정대리인의 성명, 연락처와 같이 최소한의 정보를 요구할 수 있으며, 아래
								방법으로 법정대리인의 동의를 확인합니다.
							</p>
							<ul className="bullet-dash">
								<li className="bullet">법정대리인의 휴대전화 본인인증을 통해 본인여부를 확인하는 방법</li>
								<li className="bullet">
									법정대리인에게 동의내용이 적힌 서면을 제공하여 서명날인 후 제출하게 하는 방법
								</li>
								<li className="bullet">
									그 밖에 위와 준하는 방법으로 법정대리인에게 동의내용을 알리고 동의의 의사표시를 확인하는 방법
								</li>
							</ul>
						</li>
					</ol>
				</div>
				<div className="terms-box">
					<h4 className="terms-title">7. 개인정보 수집 장치의 설치, 운영 및 거부에 관한 사항</h4>
					<p>
						회사는 이용자들에게 특화된 맞춤서비스를 제공하기 위해서 이용자들의 정보를 수시로 저장하고 찾아내는
						‘쿠키(cookie)’ 등을 운용합니다. 쿠키란 웹사이트를 운영하는데 이용되는 서버가 이용자의 컴퓨터 브라우저에
						보내는 소량의 정보이며 이용자들의 컴퓨터 하드 디스크에 저장됩니다. 회사는 다음과 같은 목적을 위해 쿠키를
						사용합니다.
					</p>
					<ol className="terms-depth">
						<li className="depth">
							<span>1)</span>쿠키 등 사용 목적 및 거절
							<ol className="terms-depth">
								<li className="depth">
									<span>①</span> 회원과 비회원의 접속 빈도나 방문 시간 등을 분석, 이용자의 취향과 관심분야를 파악 및
									자취 추적, 각종 이벤트 참여 정도 및 방문 회수 파악 등을 통한 타켓 마케팅 및 개인 맞춤 서비스 제공
								</li>
								<li className="depth">
									<span>②</span>이용자는 쿠키 설정에 대한 선택권을 가지고 있습니다. 따라서, 이용자는 웹 브라우저에서
									옵션을 설정함으로써 모든 쿠키를 허용하거나, 쿠키가 저장될 때마다 확인을 거치거나, 아니면 모든 쿠키의
									저장을 거부할 수도 있습니다.
								</li>
							</ol>
						</li>
						<li className="depth">
							<span>2)</span>쿠키 설정 거부 방법
							<p>
								쿠키 설정을 거부하는 방법으로는 이용자가 사용하는 웹 브라우저의 옵션을 선택함으로써 모든 쿠키를
								허용하거나 쿠키를 저장할 때마다 확인을 거치거나, 모든 쿠키의 저장을 거부할 수 있습니다. 단, 귀하께서
								쿠키 설치를 거부하였을 경우 로그인이 필요한 일부 서비스는 서비스 제공에 어려움이 있을 수 있습니다 .
							</p>
							<ul className="bullet-dash">
								<li className="bullet">
									설정방법(인터넷 익스플로러의 경우): 웹 브라우저 상단의 도구 {'>'} 인터넷 옵션 {'>'} 개인정보 {'>'}{' '}
									고급(“자동으로 쿠키 처리 안 함” 체크)
								</li>
								<li className="bullet">
									설정방법(크롬의 경우): 브라우저 우측 상단 설정 {'>'} 보안 및 개인정보 보호 {'>'} 쿠키 및 기타 사이트
									데이터 {'>'} 쿠키 차단
								</li>
							</ul>
						</li>
					</ol>
				</div>
				<div className="terms-box">
					<h4 className="terms-title">8. 개인정보의 안전성 확보조치</h4>
					<p>
						회사는 이용자의 개인정보를 취급함에 있어 개인정보가 분실, 도난, 누출, 변조 또는 훼손되지 않도록 안전성
						확보를 위하여 다음과 같은 기술적/관리적 대책을 강구하고 있습니다. 본 방침에서 정하지 않은 사항에 관하여는
						개인정보 보호법 제29조, 시행령 제30조, 개인정보의 안전성 확보조치 기준에서 규정하는 바에 따릅니다.
					</p>
					<ol className="terms-depth">
						<li className="depth">
							<span>1)</span>기술적 조치: 개인정보의 암호화, 보안프로그램 설치 및 운영, 접근통제시스템 설치,
							개인정보처리시스템 등의 접근권한 관리 등
						</li>
						<li className="depth">
							<span>2)</span>관리적 조치: 내부관리계획 수립 및 시행, 개인정보취급자 최소화 및 교육 시행 등
						</li>
						<li className="depth">
							<span>3)</span>물리적 조치: 전산실, 자료보관실 등의 접근통제 등
						</li>
					</ol>
					<p>
						이용자 본인의 부주의나 인터넷상의 문제로 비밀번호 등 개인정보가 유출되어 발생한 문제에 대해 회사는 일체의
						책임을 지지 않습니다.
					</p>
				</div>
				<div className="terms-box">
					<h4 className="terms-title">9. 개인정보 보호책임자 및 담당자의 연락처</h4>
					<p>
						이용자는 회사의 서비스를 이용하시며 발생하는 모든 개인정보보호 관련 민원(개인정보 열람청구 포함)을 개인정보
						보호책임자 혹은 담당부서로 신고하실 수 있습니다. 회사는 이용자들의 신고사항에 대해 신속하게 충분한 답변을
						드릴 것입니다.
					</p>
					<div className="table table-col align-center">
						<table>
							<colgroup>
								<col style={{ width: '15%' }} />
								<col style={{ width: '22%' }} />
								<col />
							</colgroup>
							<thead>
								<tr>
									<th>구분</th>
									<th>부서명</th>
									<th>이름</th>
									<th>직책/직급</th>
									<th>연락처/이메일</th>
								</tr>
							</thead>
							<tbody>
								<tr>
									<td>개인정보 보호책임자</td>
									<td>ICT본부</td>
									<td>장재화</td>
									<td>CISO/상무</td>
									<td>
										02-799-2539
										<br />
										jhchang9072@finger.co.kr
									</td>
								</tr>
								<tr>
									<td>개인정보 보호관리자</td>
									<td>Information Security Team</td>
									<td>김진환</td>
									<td>부장</td>
									<td>
										1544-9350(대)
										<br />
										jinhwan@finger.co.kr
									</td>
								</tr>
							</tbody>
						</table>
					</div>
				</div>
				<div className="terms-box">
					<h4 className="terms-title">10. 권익침해 구제방법</h4>
					<p>이용자는 개인정보침해로 인한 신고나 상담이 필요하신 경우 아래 기관에 문의하시기 바랍니다.</p>
					<ol className="terms-depth">
						<li className="depth">
							<span>1)</span> 개인정보분쟁조정위원회 (
							<a
								href="https://www.kopico.go.kr"
								className="text-link"
								target="_blank"
								title="개인정보분쟁조정위원회 홈페이지 새창 열림"
								rel="noreferrer">
								www.kopico.go.kr
							</a>{' '}
							/ 1833-6972)
						</li>
						<li className="depth">
							<span>2)</span> 한국인터넷진흥원 개인정보침해신고센터 (
							<a
								href="https://privacy.kisa.or.kr"
								className="text-link"
								target="_blank"
								title="한국인터넷진흥원 개인정보침해신고센터 홈페이지 새창 열림"
								rel="noreferrer">
								privacy.kisa.or.kr
							</a>{' '}
							/ 118)
						</li>
						<li className="depth">
							<span>3)</span> 대검찰청 사이버수사과 (
							<a
								href="https://www.spo.go.kr"
								className="text-link"
								target="_blank"
								title="대검찰청 사이버수사과 홈페이지 새창 열림"
								rel="noreferrer">
								www.spo.go.kr
							</a>{' '}
							/ 1301)
						</li>
						<li className="depth">
							<span>4)</span> 경찰청 사이버안전국 (
							<a
								href="https://cyberbureau.police.go.kr"
								className="text-link"
								target="_blank"
								title="경찰청 사이버안전국 홈페이지 새창 열림"
								rel="noreferrer">
								cyberbureau.police.go.kr
							</a>{' '}
							/ 182)
						</li>
					</ol>
				</div>
				<div className="terms-box">
					<h4 className="terms-title">11. 고지의 의무</h4>
					<p>
						현 개인정보처리방침의 내용 추가, 삭제 및 수정이 있을 시에는 개정 최소 7일전 사이트 및 이메일을 통해 고지할
						것입니다. 다만 개인정보의 수집 및 활용, 제3자 제공 등과 같이 이용자 권리의 중요한 변경이 있을 경우에는 최소
						30일 전에 고지합니다. 이 경우 회사는 개정 전 내용과 개정 후 내용을 명확하게 비교하여 회원이 알기 쉽도록
						표시합니다.
					</p>
				</div>
				<div className="terms-box">
					<h4 className="terms-title">12. 개인정보 처리방침의 변경</h4>
					<p>
						회사는 법률이나 서비스의 변경사항을 반영하기 위한 목적 등으로 개인정보 처리방침을 수정할 수 있습니다.
						개인정보 처리방침이 변경되는 경우 변경 사항을 게시하며, 변경된 개인정보 처리방침은 게시한 날로부터 7일
						후부터 효력이 발생합니다.
					</p>
				</div>
				<div className="terms-box">
					<p>시행 일자: 2025년 04월 10일</p>
				</div>
			</div>
		</>
	);
};

export default Privacy250410;
